export const getObjectForAccordionsOpenState = (dataForAccordions) => {
  const isOpenStatusForEventsObject = {};
  [dataForAccordions ? dataForAccordions : []].map(event => {
    isOpenStatusForEventsObject[event.raceIndex] = false;
    return event;
  });
  return isOpenStatusForEventsObject;
}